<div class="question-pull" [id]="'specified-items-accordion'">
  @for (item of enteredItems; track item; let i = $index; let last = $last) {
    <div class="card card--freeform">
      <a [href]="'#' + ((item?.Name && item?.Surname) ? 'drop-accordion' : 'add-item') + '-' + (i +1)"
        class="card-title"
        data-toggle="collapse" aria-expanded="false" [class.collapsed]="joinString(item.Name, item.Surname) || !last">
        <div class="card-title__text">
          <svg class="icon icon--lg">
            <use [attr.xlink:href]="'#cart-discount'"></use>
          </svg>
          <div class="card-title__text-wrap">
            <h4>{{(item?.Name && item?.Surname) ? joinString(item.Name, item.Surname) : 'Add Family Member'}}</h4>
            <p>{{questionService?.accounting?.formatMoney(item?.FuneralCoverAmount)}}</p>
          </div>
        </div>
        <div class="card-title__cost is-active">
          <p><strong>{{questionService?.accounting?.formatMoney(item?.Premium)}}</strong> /{{questionService?.currency?.display_freq}}</p>
        </div>
        <div class="card-title__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
      <div class="card-body collapse"
        [id]="((item?.Name && item?.Surname) ? 'drop-accordion' : 'add-item') + '-' + (i +1)"
        [attr.data-parent]="'#specified-items-accordion'"
        [class.show]="!joinString(item.Name, item.Surname) || last">
        <div class="card__content">
          @for (question of item?.questions; track question; let questionIndex = $index) {
            @if (question.cent_aq_question_type_id == questionType.dropdown) {
              <div class="form-group form-group--lg ui-front">
                <app-question-dropdown
                  [question]="question"
                  [showLabel]="true"
                  [labelText]="question.question_prompt"
                  (questionAnswer)="selectChange($event, questionIndex, i)">
                </app-question-dropdown>
              </div>
            }
            @if (question.cent_aq_question_type_id == questionType.textbox) {
              <div class="form-group form-group--lg">
                <app-question-textbox
                  [question]="question"
                  [showLabel]="true"
                  (questionAnswer)="onInputChange($event, questionIndex, i)">
                </app-question-textbox>
              </div>
            }
            @if (question.cent_aq_question_type_id == questionType.currency) {
              <div class="form-group form-group--lg">
                <app-question-currency
                  [question]="question"
                  [showLabel]="true"
                  (questionAnswer)="onInputChange($event, questionIndex, i)">
                </app-question-currency>
              </div>
            }
            @if (question.cent_aq_question_type_id == questionType.dob) {
              <div class="form-group form-group--lg">
                <app-question-date-of-birth
                  [question]="question"
                  (questionAnswer)="onInputChange($event, questionIndex, i)">
                </app-question-date-of-birth>
              </div>
            }
          }
          @if (showRemove) {
            <div class="card__tray">
              <div class="card__actions">
                <a href="javascript:;" (click)="removeItem(i)" class="text-link">Remove</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <!-- /card -->
</div>
